export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/monster_video_screenshot-ec5da5184f0fc74f8aefd2eb9977818f.png";